import { initWXShare } from '@/utils/js/js-sdk.js'
import { getParams } from '@/utils/js/utils.js'

export default {
  methods: {},

  watch: {
    $route: function (to) {
      // 解决getOpenId接口调两次的问题
      let urlParams = getParams()
      // 在路由改变时初始微信分享功能
      //customShare如果是true就做自定义分享，则app不调用初始化  自定义方法调用
      if (to.meta.client === 'wx' && !to.meta.wx.customShare) {
        // 初始化分享的时候不执行回调的方法
        initWXShare(to.meta.wx)
      }
    },
  },
}
